import { ca } from '@cian/analytics';

export function trackFeedbackButtonClick() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_survey',
    label: 'about_new_design',
  });
}
